export default __webpack_public_path__ + "static/media/warning--golf-carts-crossing--g1.6d3a5336.png";